import React from "react";
import Section from "./Section";

function LegalTerms(props) {
  return (
    <Section
      size="md"
      bgColor="bg-white"
      bgImage=""
      bgImageOpacity={1}
      textColor=""
    >
      <div className="container max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg">
          <p className="text-gray-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
          <p className="mb-4">
            By accessing and using the SMSushi reservation system, you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use our reservation system.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">2. Reservation System Usage</h2>
          <p className="mb-4">
            Our reservation system is provided for the purpose of making dining reservations at SMSushi. You agree to:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Provide accurate and complete information when making reservations</li>
            <li>Use the system in accordance with all applicable laws and regulations</li>
            <li>Not attempt to manipulate or abuse the reservation system</li>
            <li>Not make multiple reservations for the same time slot</li>
            <li>Arrive on time for your reservation</li>
            <li>Cancel reservations at least 24 hours in advance if you cannot attend</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">3. Cancellation Policy</h2>
          <p className="mb-4">
            We require at least 24 hours notice for reservation cancellations. Late cancellations or no-shows may result in:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Loss of future reservation privileges</li>
            <li>Potential charges for special events or large group reservations</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">4. Restaurant Policies</h2>
          <p className="mb-4">
            By making a reservation, you agree to comply with our restaurant policies:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Dress code requirements</li>
            <li>Maximum seating time limits</li>
            <li>Outside food and beverage policies</li>
            <li>Special dietary accommodation procedures</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">5. Modifications to Service</h2>
          <p className="mb-4">
            We reserve the right to modify or discontinue our reservation system at any time, with or without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the service.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
          <p className="mb-4">
            SMSushi shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use the reservation system.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">7. Contact Information</h2>
          <p className="mb-4">
            For questions about these Terms of Service, please contact us at:
          </p>
          <p className="mb-4">
            Email: [Your Contact Email]<br />
            Phone: [Your Phone Number]<br />
            Address: [Your Restaurant Address]
          </p>
        </div>
      </div>
    </Section>
  );
}

export default LegalTerms;
